import { useEffect } from "react";

import { useDeviceInfo } from "@swa-ui/browser";
import { logger } from "@swa-ui/log";

/**
 * LogDisable uses device info context to disable the logging mechanism for externally hosted sites.
 */
export const LogDisable = () => {
  const { isVendorHosted } = useDeviceInfo();

  useEffect(() => {
    if (isVendorHosted) {
      logger.disable();
    }
  }, [isVendorHosted]);

  return null;
};
